export default __webpack_public_path__ + "static/media/SHIB.46c02907.svg";